/**
 * File formats
 *
 * Please, contribute if you need a missing file format
 */
export enum FileFormat {
  JPG = 'jpg',
  JPEG = 'jpeg',
  PNG = 'png',
  GIF = 'gif',
  ICO = 'ico',
  SVG = 'svg',
  MP3 = 'mp3',
  MP4 = 'mp4',
  MOV = 'mov',
  WAV = 'wav',
  CSV = 'csv',
  PDF = 'pdf',
  TXT = 'txt',
  XML = 'xml',
  XLS = 'xls',
  XLSX = 'xlsx',
  DOC = 'doc',
  XDOC = 'xdoc',
}
